<template>
  <v-col class="mx-4 pt-1">
    <div class="d-flex">
      <div
        class="py-0 my-0 pl-0"
        style="color: #23468c; line-height: 45px; font-weight: 500"
      >
        Find a Pick & Collect Location
      </div>
      <v-spacer></v-spacer>
      <v-col
        cols="12"
        md="3"
        class="pt-0 pb-1"
        v-if="$store.getters.user.user_category == 3"
        style="margin-left: auto"
      >
        <v-autocomplete
          v-model="selectedClientId"
          :items="clients"
          :loading="clientLoader"
          item-text="name"
          item-value="id"
          label="Select Client"
          placeholder="Start typing to Search"
          class="required pb-0"
          :rules="[(v) => !!v || 'Please Select Client']"
          outlined
          dense
          hide-details
          @change="getConfigType()"
        ></v-autocomplete>
      </v-col>
    </div>
    <v-divider class="mt-1"></v-divider>
    <v-card>
      <v-card-text dense>
        <v-form ref="form">
          <v-row>
            <v-col
              style="text-align: center"
              cols="12"
              md="12"
              class="pb-0 pt-1"
              v-if="!selectedClientId"
              >Please Select Client</v-col
            >
            <v-col cols="12" md="2" class="d-flex pb-0" v-if="selectedClientId">
              <v-autocomplete
                v-model="selectedSourceCountry"
                :items="fromCountries"
                item-text="name"
                item-value="id"
                label="Source Country"
                placeholder="Start typing to Search"
                class="required pb-0"
                :rules="[(v) => !!v || 'Please Select Source Country']"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2" class="d-flex pb-0" v-if="selectedClientId">
              <v-autocomplete
                v-model="selectedToCountry"
                :items="toCountries"
                item-text="name"
                item-value="id"
                label="Destination Country"
                placeholder="Start typing to Search"
                class="required pb-0"
                @change="fetchCity()"
                :rules="[(v) => !!v || 'Please Select Destination Country']"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2" class="d-flex pb-0" v-if="selectedClientId">
              <v-autocomplete
                v-model="city_id"
                :items="cities"
                outlined
                label="Destination City"
                placeholder="Start typing to Search"
                item-text="name"
                item-value="id"
                :loading="cityLoader"
                dense
                class="required pb-0"
                :rules="[(v) => !!v || 'Please Select Destination City']"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2" md="2" class="pb-0" v-if="selectedClientId">
              <v-autocomplete
                label="Payment Mode"
                :items="paymentModes"
                v-model="payment_type"
                :rules="[(v) => !!v || 'Please Select Payment Mode.']"
                class="required pb-0"
                item-value="value"
                outlined
                placeholder="Start typing to Search"
                item-text="text"
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="2" md="2" class="pb-0" v-if="selectedClientId">
              <v-autocomplete
                label="Duty Handlings"
                :items="duty_handlings"
                v-model="duty_handling"
                :rules="[(v) => !!v || 'Please Select Duty Handling.']"
                class="required pb-0"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2" class="pb-0" v-if="selectedClientId">
              <v-autocomplete
                v-model="delivery_type"
                :items="deliveryTypes"
                label="Delivery Type"
                class="required pb-0"
                :rules="[(v) => !!v || 'Please Select Duty Handling.']"
                outlined
                dense
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" class="pb-0" v-if="selectedClientId">
              <v-text-field
                v-model="address"
                label="Address"
                class="required pb-0"
                :rules="[(v) => !!v || 'Please Enter Address.']"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="pb-0" v-if="selectedClientId">
              <v-text-field
                v-model="zipcode"
                label="Zipcode"
                class="required pb-0"
                outlined
                dense
                hide-details="auto"
                :rules="[(v) => !!v || 'Please Enter Zipcode.']"
              ></v-text-field>
            </v-col>
            <v-col
              cols="4"
              :md="$store.getters.user.user_category == 3 ? 6 : 6"
              class="pl-0 pb-0"
              v-if="selectedClientId"
            >
              <v-btn
                color="white"
                @click="clearAll()"
                class="ml-4 mb-10"
                style="float: right"
                >Clear</v-btn
              >
              <v-btn
                color="primary"
                @click="saveData"
                class="ml-4 mb-10"
                style="float: right"
                >Search</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="mb-4" v-if="selectedClientId"></v-divider>
        <v-progress-linear
          indeterminate
          color="primary"
          height="2"
          v-if="routes.length == 0 && loading"
        ></v-progress-linear>
        <div
          class="card-container"
          v-if="routes.length > 0"
          style="height: calc(100vh - 350px); overflow-y: auto"
        >
          <v-card
            class="route-card pa-2 mb-2"
            elevation="2"
            v-for="route in routes"
            :key="route.id"
          >
            <v-row no-gutters align="center">
              <v-col cols="auto" class="mr-3">
                <v-icon size="24">mdi-map-marker</v-icon>
              </v-col>
              <v-col>
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="text-subtitle-1 font-weight-medium">
                      {{ route.Agencenom }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <span class="text-caption text-medium-emphasis">{{
                      route.Depositairenom
                    }}</span>
                    <span class="text-caption text-medium-emphasis">{{
                      route.formattedAddressLine
                    }}</span
                    ><br />
                    <span class="text-caption text-medium-emphasis">{{
                      route.Xeett
                    }}</span
                    >,
                    <span class="text-caption text-medium-emphasis">{{
                      route.countryLabel
                    }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="auto" class="text-right">
                <div class="text-caption">{{ route.distance }}</div>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  async created() {
    if (this.$store.getters.user.user_category == 1) {
      this.selectedClientId = this.$store.getters.user.id;
      this.getConfigType();
    } else {
      await this.fetchClientList();
    }
  },
  async mounted() {},
  watch: {},
  computed: {},
  data() {
    return {
      loading: false,
      routes: [],
      area_list: [],
      fileLoader: false,
      filePin: null,
      uploadPinForm: false,
      payment_type: null,
      uploadForm: false,
      uploadAreaForm: false,
      sericesTypes: [],
      sericesType: "",
      deliveryTypes: [
        { text: "Cross Border", value: "crossborder" },
        { text: "Domestic", value: "domestic" },
      ],
      clientLoader: false,
      clients: [],
      selectedClientId: null,
      fromCountries: [],
      toCountries: [],
      selectedSourceCountry: null,
      selectedToCountry: null,
      selectedTransitCountry: null,
      fromFLag: "",
      to: "",
      transitFlag: "",
      originAgent: [],
      transitPartner: [],
      origin_agent: null,
      transit_partner: null,
      objArr: {},
      selectedCarrier: [],
      transitCountry: "",
      countryLoader: false,
      transitLoader: false,
      duty_handlings: [],
      selectedDutyHandling: null,
      dutyhandlings: [
        { text: "DDU", value: "ddu" },
        { text: "DDP", value: "ddp" },
      ],
      dutyhandlingsNull: [],
      delivery_type: null,
      linehaul_id: null,
      file: null,
      is_area_required: false,
      city_list: [],
      fileArea: null,
      areaShow: false,
      is_pincode_required: false,
      paymentModes: [],
      cities: [],
      crossborder_services: [],
      domestic_services: [],
      city_id: null,
      address: null,
      zipcode: null,
      duty_handling: null,
    };
  },
  methods: {
    ...mapActions([
      "fetchClient",
      "snackBar",
      "getTransitCountry",
      "searchPudoLocation",
      "getPudoConfiguration",
      "fetchCityList",
    ]),
    fetchCity() {
      this.cities = [];
      this.country_code = this.toCountries.find(
        (e) => e.id == this.selectedToCountry
      ).code;
      this.cityLoader = true;
      this.fetchCityList(this.country_code).then((res) => {
        this.cities = res.data;
        this.cityLoader = false;
      });
    },

    fetchClientList() {
      if (this.clients.length) return;
      this.clientLoader = true;
      this.fetchClient({
        service: "clickdna,fulfillment_wid_last_mile",
      })
        .then((res) => {
          this.clientLoader = false;
          this.clients = res.data;
        })
        .catch(() => {
          this.clientLoader = false;
        });
    },
    async getConfigType() {
      if (this.selectedClientId !== null) {
        this.countryLoader = true;
        this.fromCountries = [];
        this.toCountries = [];
        await this.getPudoConfiguration(this.selectedClientId)
          .then((response) => {
            this.paymentModes = response.data.payment_type;
            this.fromCountries = response.data.origin_country;
            this.toCountries = response.data.destination_country;
            this.duty_handlings = response.data.duty_handling;
            this.crossborder_services = response.data.crossborder_services;
            this.domestic_services = response.data.domestic_services;
          })
          .catch(() => {
            this.countryLoader = false;
            this.fromCountries = [];
            this.toCountries = [];
          });
      }
    },
    clearAll() {
      this.selectedToCountry = null;
      this.selectedSourceCountry = null;
      this.duty_handling = null;
      this.delivery_type = null;
      this.payment_type = null;
      this.sericesType = null;
      this.city_id = null;
      this.address = null;
      this.zipcode = null;
      if (this.$store.getters.user.user_category == 1) {
        this.selectedClientId = this.$store.getters.user.id;
      } else {
        this.selectedClientId = null;
      }
      this.routes = [];
      this.objArr = {};
    },

    saveData() {
      if (!this.$refs.form.validate()) return;
      let obj = {
        source_country_id: this.selectedSourceCountry,
        destination_country_id: this.selectedToCountry,
        destination_city_id: this.city_id,
        payment_type: this.payment_type,
        duty_handling: this.duty_handling,
        address: this.address,
        zipcode: this.zipcode,
        delivery_type: this.delivery_type,
        client_id: this.selectedClientId,
      };
      if (this.$store.getters.user.user_category == 1) {
        delete obj.client_id;
      }
      this.loading = true;
      this.searchPudoLocation(obj)
        .then((result) => {
          this.routes = result.data;
          this.loading = false;
        })
        .catch(() => {
          // this.snackBar({
          //   color: "error",
          //   message: e[0],
          // });
          this.routes = [];
          this.loading = false;
        });
    },
  },
};
</script>
<style>
.route-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}
.logo {
  max-width: 100px;
  max-height: 20px;
}
.carrier-logo {
  width: 81px;
  height: 52px;
}
</style>
